import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { curry, equals, filter, findIndex, not, pipe } from 'ramda';
export var FiltersActionTypes;

(function (FiltersActionTypes) {
  FiltersActionTypes["Toggle"] = "webtv/filters/Toggle";
  FiltersActionTypes["ClearFilters"] = "webtv/filters/ClearFilters";
  FiltersActionTypes["Sort"] = "webtv/filters/Sort";
})(FiltersActionTypes || (FiltersActionTypes = {}));

// Action Creators
export var toggle = function toggle(name, value) {
  return {
    type: FiltersActionTypes.Toggle,
    payload: {
      name: name,
      value: value
    }
  };
};
export var clearFilters = function clearFilters() {
  return {
    type: FiltersActionTypes.ClearFilters
  };
};
export var sort = function sort(sortValue) {
  return {
    type: FiltersActionTypes.Sort,
    payload: {
      sortValue: sortValue
    }
  };
}; // Helpers

var doesMatchName = curry(function (f1, f2) {
  return f1.name === f2.name;
});
var doesMatchNameAndValue = curry(function (f1, f2) {
  return equals(f1, f2);
});

var hasExactMatch = function hasExactMatch(f, appliedFilters) {
  return findIndex(doesMatchNameAndValue(f), appliedFilters) > -1;
};

var remove = function remove(f, appliedFilters) {
  return filter(pipe(doesMatchNameAndValue(f), not), appliedFilters);
};

var update = function update(f, appliedFilters) {
  return [].concat(_toConsumableArray(filter(pipe(doesMatchName(f), not), appliedFilters)), [f]);
}; // Reducer


export var DEFAULT_STATE = {
  applied: [],
  sort: 'original_air_time-desc'
};
export var filtersReducer = function filtersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case FiltersActionTypes.Toggle:
      return _objectSpread(_objectSpread({}, state), {}, {
        applied: hasExactMatch(action.payload, state.applied) ? remove(action.payload, state.applied) : update(action.payload, state.applied)
      });

    case FiltersActionTypes.Sort:
      return _objectSpread(_objectSpread({}, state), {}, {
        sort: action.payload.sortValue
      });

    case FiltersActionTypes.ClearFilters:
      return DEFAULT_STATE;

    default:
      return state;
  }
};